import React from "react";
import ErrorBoundary from "../ErrorBoundary/ErrorBoundary";

const PageWrapper = ({ children }) => {
  return (
    <ErrorBoundary>
      <div className="page-fill">{children}</div>
    </ErrorBoundary>
  );
};

export default PageWrapper;
